<template>
  <main>
    <div class="long-wrap">
      <Intro/>
      <Portfolio/>
      <Team/>
      <Contacts/>
    </div>
  </main>
</template>

<script>
  import Intro from './Intro';
  import Portfolio from './Portfolio';
  import Team from './Team';
  import Contacts from './Contacts';

  export default {
    name: 'Main',
    components: { Contacts, Team, Portfolio, Intro },
    mounted() {
      this.$el.addEventListener('wheel', this.userScrolled);
    },

    methods: {
      userScrolled(event) {
        const isHorizontalScrolling = event.deltaX !== 0;
        if(isHorizontalScrolling) {
          return;
        }

        const isVerticalScreen = document.documentElement.clientWidth <= document.documentElement.clientHeight;
        const isVerticalScrolling = isVerticalScreen;
        if(isVerticalScrolling) {
          return;
        }

        event.preventDefault();
        const scrollMultiplier = event.mozInputSource ? 25 : 1;
        this.$el.scrollLeft += event.deltaY * scrollMultiplier;
        //console.log(event);
      }
    }
  };
</script>

<style lang="less" scoped>
  @import (reference) '../shared.less';

  main {
    flex-shrink: 0;
    flex-grow: 1;
    padding-bottom: @margins[long-v-padding];
    -webkit-overflow-scrolling: touch;
    overflow-x: scroll;
    transform: translateZ(0);
    display: flex;
    .hide-scrollbar();

    @media @vertical {
      padding-bottom: @margins-v[long-v-padding];
      overflow-x: unset;
    }

    @media @mobile {
      padding-bottom: @margins-m[long-v-padding];
    }

    @media @mobile-vertical {
      padding-bottom: @margins-mv[long-v-padding];
    }
  }

  .long-wrap {
    flex-grow: 1;
    flex-shrink: 0;
    display: flex;

    @media @vertical {
      flex-direction: column;
      flex-grow: 0;
      flex-shrink: 1;
      overflow-x: hidden;
    }
  }
</style>
